<script lang="ts">
	/**
	 * `/Product/:slug` while it loads, in its own two columns: the description and the checkout
	 * steps on the left, the sticky purchase rail on the right (`lg:grid-cols-3`, the content taking
	 * two). The rail is where the eye goes first, so it is the part that must not appear late.
	 */
	import Bone from './Bone.svelte';
</script>

<div role="status" aria-label="Loading the product" class="animate-pulse">
	<Bone class="h-3 w-48 mb-6" />
	<Bone class="h-8 w-72 mb-3" />
	<Bone class="h-3 w-96 max-w-full mb-8" />
	<div class="grid gap-6 lg:grid-cols-3 items-start">
		<div class="lg:col-span-2 space-y-6">
			<div class="widget bg-depth space-y-3">
				<Bone class="h-4 w-32" />
				<Bone class="h-2.5 w-full" />
				<Bone class="h-2.5 w-11/12" />
				<Bone class="h-2.5 w-10/12" />
				<Bone class="h-2.5 w-9/12" />
			</div>
			<div class="widget bg-depth space-y-3">
				<Bone class="h-4 w-40" />
				<div class="grid gap-x-6 gap-y-2 sm:grid-cols-2">
					{#each Array(6) as _feature, index (index)}
						<Bone class="h-2.5 w-10/12" />
					{/each}
				</div>
			</div>
			<div class="widget bg-depth space-y-4">
				{#each Array(3) as _step, index (index)}
					<div class="flex items-center gap-3">
						<Bone class="w-6 h-6 shrink-0" />
						<Bone class="h-3 w-48" />
					</div>
				{/each}
			</div>
		</div>
		<div class="widget bg-depth space-y-4">
			<Bone class="h-8 w-40" round="xl" />
			<Bone class="h-20 w-full" round="xl" />
			<Bone class="h-20 w-full" round="xl" />
			<div class="space-y-2 pt-2">
				<Bone class="h-3 w-full" />
				<Bone class="h-3 w-full" />
				<Bone class="h-4 w-1/2" />
			</div>
		</div>
	</div>
	<span class="sr-only">Loading…</span>
</div>
